import * as download from './download.js';
import * as list from './list.js';

export const jobs = [download, list];
